export const Props = () =>({
    // Название коина для зпроса api
    coinId:{
        type: String,
    }
})
